// extracted by mini-css-extract-plugin
module.exports = {"wrap":"order-calculation_wrap__VwTSz","row":"order-calculation_row__qJb1p","sumRow":"order-calculation_sumRow___f7hc","subNoteRow":"order-calculation_subNoteRow__U5pS4"};